
















































































import { Component, Mixins, Prop, Vue, Emit } from 'vue-property-decorator';
import { Lazy, EventBus, TypeEventBus } from '../../core/utils';
import { AuthStoreHelper, RootStoreHelper } from '../../core/mixins';
@Component
export default class StatsPanel extends Mixins(RootStoreHelper, AuthStoreHelper) {
    @Prop() open: boolean;
    @Prop() actualState: any;
    @Prop() openPanel: Lazy<void>;
    @Prop() closePanel: Lazy<void>;
    @Prop() items: string[];
    @Prop() slotTabs: string[];
    @Prop() customHeight: number;
    @Prop() overflowStats: boolean;
    @Prop() overflowCard: boolean;
    @Prop() expanded: boolean;
    @Prop() shouldShowRemoveSecondFilterButton: boolean;
    tab: number | null = null;

    get getGTMClassStatsPanelTrigger() {
        if (!this.$store.state.userGroupSmartway) {
            return this.actualState
                ? 'ga_btn_tracking_trigger_actual_state_panel'
                : 'ga_btn_tracking_trigger_statistics_panel';
        }
        return '';
    }

    getGTMClasses(button) {
        switch (button) {
            case 1:
                return 'ga_btn_tracking_statistics_panel_undo';
            case 2:
                return 'ga_btn_tracking_minimize_statistics_panel';
        }
    }

    mounted(){
        this.selectTab(1);

        EventBus.$on(TypeEventBus.RESET_TAB_POSITION, payload => {
            this.selectTab(0)
        });
    }

    get isPanelOpened() {
        return this.openPanel;
    }

    handleRemoveSecondFilter() {
        if (!this.$_isMock) {
            this.removeSecondFilter();
        }
    }

    @Emit()
    tabItemClick(item) {}

    @Emit()
    removeSecondFilter() {}

    @Emit()
    toggleExpand(value) {
        return value;
    }

    toggleMinimizeState() {
        if (!this.$_isMock) {
            if (this.open) {
                EventBus.$emit(TypeEventBus.TOGGLE_PANEL_MINIMIZED, true);
                this.closePanel();
                this.$_setLoadingCursor(false);
                
            } else {
                EventBus.$emit(TypeEventBus.TOGGLE_PANEL_MINIMIZED, false);
                this.toggleExpand(false);
                this.openPanel();
                this.$_setLoadingCursor(false);
            }
        }
    }

    get heightControl() {
        return !this.open ? 10 : this.customHeight;
    }

    get iconControl() {
        return this.open ? 'insert_chart' : 'insert_chart';
    }

    selectTab(index: number): void {
        this.tab = index;
    }
}
